// VEVOタブを表示する対象施設のリスト
// family APIのレスポンスに施設ID(nurseryId)が含まれないため、施設名(nurseryName)で判定する
// 施設名が変更されるとこの判定が壊れるため、リネーム時はこのリストも更新すること
export const VEVO_ENABLED_NURSERY_NAMES: string[] = [
  'AIAI NURSERY 豊四季',
  'AIAI NURSERY 鴫野駅前',
  'AIAI NURSERY 第二東池袋',
  'おが〜る園',
  '森田請求確認施設',
  '深田さんテスト施設',
  'stg_VEVOレポート検証',
  'stgvevoレポート',
  'マニュアル保育園',
  'リリース時確認施設',
  '20260716_VEVOレポート検証',
  'DEV環境AIレポートテスト園',
  '内製化会議デモ',
  'Lambda_devテスト施設',
  'Lambda_stgテスト施設'
];

export function isVevoEnabledNursery(
  nurseryName: string | null | undefined,
): boolean {
  if (!nurseryName) {
    return false;
  }
  return VEVO_ENABLED_NURSERY_NAMES.includes(nurseryName);
}

/** システム固定のレポート言語 */
export const VEVO_STORED_LANGUAGES = ['en', 'ja', 'km'] as const;
export type VevoStoredLanguage = (typeof VEVO_STORED_LANGUAGES)[number];

export type VevoReportLanguage = VevoStoredLanguage | string;

/** 言語コード → 表示ラベル (i18n キーが無いシステム外言語用フォールバック含む) */
export const VEVO_LANGUAGE_FALLBACK_LABELS: Record<string, string> = {
  en: 'English',
  ja: 'Japanese',
  km: 'Khmer',
  ko: 'Korean',
  zh: 'Chinese',
  vi: 'Tiếng Việt',
  hi: 'Hindi',
  ru: 'Russian',
  bn: 'Bengali',
  mn: 'Mongolian',
  tl: 'Tagalog',
  ms: 'Malay',
};
